import "./depositOffersItemCard.scss";
// vendors
import React from "react";
import classNames from 'classnames';
// components
import OfferBodyTag from "../offerBodyTag/offerBodyTag";
import { OKButton } from 'components/commons/OKButton/OKButton';

function DepositOffersItemCard({
    isAlternativeFlavor,
    isLargeDisplayOption,
    offerText,
    tagText,
    tagStrings,
    buttonText,
    buttonRemoveOfferText,
    handleClick,
    onOpenRemoveOfferModal,
    secondaryButtonText = null,
    handleSecondaryButtonClick = null
}) {
    const mainClassName = classNames('deposit-offer-item-card', {
        'deposit-offer-item-card--cc': __CONTACT_CENTER__ && (!isLargeDisplayOption || isAlternativeFlavor),
        'deposit-offer-item-card--alternative': isAlternativeFlavor,
    });
    const infoBoxClassName = classNames('deposit-offer-item-card__info-box', {
        'deposit-offer-item-card__info-box--cc': __CONTACT_CENTER__ && !isLargeDisplayOption
    });
    const iconClassName = classNames('deposit-offer-item-card__icon', {
        'deposit-offer-item-card__icon--cc': __CONTACT_CENTER__ && !isLargeDisplayOption,
        'deposit-offer-item-card__icon--alternative': isAlternativeFlavor,
    });
    const textBoxTitleClassName = classNames('deposit-offer-item-card__text-box-title', {
        'deposit-offer-item-card__text-box-title--cc': __CONTACT_CENTER__ && !isLargeDisplayOption
    });
    const buttonClassName = classNames('deposit-offer-item-card__button', {
        'deposit-offer-item-card__button--cc': __CONTACT_CENTER__ && (!isLargeDisplayOption || isAlternativeFlavor)
    });
    return (
        <div className={mainClassName}>
            <div className={infoBoxClassName}>
                <span className={iconClassName}></span>
                <div className='deposit-offer-item-card__text-box'>
                    <p className={textBoxTitleClassName}>
                        <span>
                            {offerText}
                        </span>
                    </p>
                    <OfferBodyTag text={tagText} strings={tagStrings} />
                </div>
            </div>
            <div className={buttonClassName}>
                <button
                    className="buttons-base buttons-base--regular buttons-base--primary"
                    onClick={handleClick}
                >
                    {buttonText}
                </button>
                {
                    isAlternativeFlavor && __CONTACT_CENTER__ && (
                        <OKButton
                            className="buttons-base buttons-base--regular buttons-base--primary"
                            modifier="link-emphasize"
                            onClick={onOpenRemoveOfferModal}
                        >
                            {buttonRemoveOfferText}
                        </OKButton>
                    )
                }
            </div>
            {secondaryButtonText && (
                <div className="deposit-offer-item-card__button">
                    <button
                        className="buttons-base buttons-base--regular buttons-base--primary"
                        onClick={handleSecondaryButtonClick}
                    >
                        {secondaryButtonText}
                    </button>
                </div>
            )}
        </div>
    );
}

export default DepositOffersItemCard;